import { FaCheck } from 'react-icons/fa6'
import AnimatedSection from '../common/AnimatedSection'
import { servicesPageServices } from '../../data/servicesPageData'

function ServicesGrid() {
  return (
    <AnimatedSection className="services-grid-section">
      <div className="container corp-container">
        <header className="services-section-header">
          <span className="section-label section-label--gold">Our Services</span>
          <h2>
            Enterprise Metal Trading <span>Services</span>
          </h2>
          <p>
            Structured international trading, sourcing, logistics and quality programs built for
            industrial procurement teams worldwide.
          </p>
        </header>

        <div className="row g-4">
          {servicesPageServices.map((service, index) => {
            const Icon = service.icon
            return (
              <div className="col-lg-6" key={service.id}>
                <article className="services-card">
                  <div className="services-card__top">
                    <span className="services-card__icon" aria-hidden="true">
                      <Icon />
                    </span>
                    <span className="services-card__num">{String(index + 1).padStart(2, '0')}</span>
                  </div>
                  <h3>{service.title}</h3>
                  <p className="services-card__desc">{service.description}</p>
                  <ul className="services-card__features">
                    {service.features.map((feature) => (
                      <li key={feature}>
                        <FaCheck aria-hidden="true" />
                        {feature}
                      </li>
                    ))}
                  </ul>
                </article>
              </div>
            )
          })}
        </div>
      </div>
    </AnimatedSection>
  )
}

export default ServicesGrid
